import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import AccountButton from "../components/AccountButton";
import InstallButton from "../components/InstallButton";
import { Loader2 } from "lucide-react";
import { IMG_ASSETS } from "../game/assets";

const LOGO = "/assets/brand/logo.png";
const ROUTES = { roue: "/roue", grattage: "/grattage", memory: "/memory" };
const EMOJI = { roue: "🎡", grattage: "🎟️", memory: "🧠" };
const TILT = ["-rotate-2", "rotate-2", "-rotate-1"];

export default function HomePage() {
  const [games, setGames] = useState(null);

  useEffect(() => {
    api.get("/games").then(({ data }) => setGames(data)).catch(() => setGames([]));
  }, []);

  return (
    <div className="min-h-screen w-full bg-yum-pattern flex flex-col items-center px-5 py-7 relative overflow-hidden text-white">
      <div className="absolute top-3 right-3 z-20"><AccountButton /></div>

      {/* Hero */}
      <img src={LOGO} alt="YÜM" className="w-40 sm:w-48 mt-6 drop-shadow-xl" data-testid="brand-logo" />

      <div className="flex flex-wrap gap-2 justify-center mt-4 mb-1">
        <span className="yum-sticker bg-sun text-ink" style={{ transform: "rotate(-4deg)" }}>🎁 100% gratuit</span>
        <span className="yum-sticker bg-white text-ink" style={{ transform: "rotate(3deg)" }}>Sans inscription</span>
      </div>

      <h1 className="font-display text-white text-center leading-[0.95] tracking-tight text-4xl sm:text-5xl mt-3">
        Joue &amp; gagne des
        <br />
        <span className="relative inline-block text-ink">
          cadeaux YÜM
          <span className="absolute left-0 -bottom-1 h-3 w-full bg-sun rounded-full -z-0" />
        </span>
      </h1>
      <p className="font-script text-sun text-3xl sm:text-4xl mt-3 text-center">
        Bubble tea, crêpes, gaufres… à gagner !
      </p>
      <p className="text-white/80 text-sm mt-2 text-center max-w-xs">
        Choisis un jeu, tente ta chance et récupère ton bon en boutique 🎉
      </p>

      {/* Jeux */}
      <div className="w-full max-w-md flex flex-col gap-5 mt-8" data-testid="games-list">
        {!games && <Loader2 className="animate-spin text-white mx-auto mt-6" size={40} />}
        {games && games.map((g, i) => {
          const to = ROUTES[g.key];
          const disabled = !g.enabled || !to;
          const inner = (
            <div
              className={`relative bg-white text-ink rounded-[26px] p-5 flex items-center gap-4 transition-transform duration-300 ${TILT[i % TILT.length]} ${disabled ? "opacity-70" : "hover:rotate-0"}`}
              style={{ boxShadow: "0 10px 0 #a81a0c" }}
            >
              <div className="flex-none w-16 h-16 rounded-2xl bg-cream grid place-items-center text-4xl">{EMOJI[g.key] || "🎮"}</div>
              <div className="min-w-0 flex-1">
                <h3 className="font-display font-bold text-xl leading-tight">{g.title}</h3>
                <p className="text-sm text-ink/60 leading-snug">{g.tagline}</p>
              </div>
              <span className={`flex-none font-display font-bold text-sm rounded-full px-5 py-2.5 ${disabled ? "bg-ink/10 text-ink/40" : "bg-brand text-white"}`}
                style={disabled ? {} : { boxShadow: "0 4px 0 #a81a0c" }}>
                {disabled ? "Bientôt" : "Jouer →"}
              </span>
              {disabled && <span className="absolute -top-2 -right-1 yum-sticker bg-ink text-white text-[11px] px-3 py-1" style={{ boxShadow: "0 3px 0 rgba(0,0,0,.3)" }}>Bientôt</span>}
            </div>
          );
          return disabled
            ? <div key={g.key} data-testid={`game-${g.key}`}>{inner}</div>
            : <Link key={g.key} to={to} data-testid={`game-${g.key}`} className="block">{inner}</Link>;
        })}

        {/* Manicou Runner — jeu d'arcade (route dédiée, hors catalogue /games) */}
        {games && (
          <Link to="/runner" data-testid="game-runner" className="block">
            <div
              className="relative bg-white text-ink rounded-[26px] p-5 flex items-center gap-4 transition-transform duration-300 -rotate-2 hover:rotate-0"
              style={{ boxShadow: "0 10px 0 #a81a0c" }}
            >
              <div className="flex-none w-16 h-16 rounded-2xl bg-cream grid place-items-center overflow-hidden">
                <img src={IMG_ASSETS.manicou} alt="Le manicou" className="w-14 h-14 object-contain" style={{ transform: "scaleX(-1)" }} />
              </div>
              <div className="min-w-0 flex-1">
                <h3 className="font-display font-bold text-xl leading-tight">Manicou Runner</h3>
                <p className="text-sm text-ink/60 leading-snug">Cours, saute et ramasse un max de gourmandises !</p>
              </div>
              <span className="flex-none font-display font-bold text-sm rounded-full px-5 py-2.5 bg-brand text-white" style={{ boxShadow: "0 4px 0 #a81a0c" }}>
                Jouer →
              </span>
            </div>
          </Link>
        )}
      </div>

      <div className="mt-10">
        <InstallButton kind="games" className="yum-sticker bg-white text-ink text-sm px-5 py-2.5" label="📲 Installer l'appli YÜM" />
      </div>

      <p className="text-white/50 text-xs mt-8">YÜM — Le François, Martinique · yummartinique.com</p>
    </div>
  );
}
